import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GlobalService } from '../providers/global.service';
import { RequestService } from '../providers/request/request.service';
import { ArchiveCatalog } from '../models/archive/archive-catalog.model';
import { BatchArchiveCatalog } from '../models/archive/batch-archive-catalog.model';
import { environment } from 'src/environments/environment';
import { ArchiveCatalogMoveRequest } from '../models/archive/archive-catalog-move-request.model';

@Injectable({
  providedIn: 'root',
})
export class ArchiveCatalogService extends RequestService<ArchiveCatalog> {
  static PATH = '/archive/catalog';
  constructor(
    public override httpClient: HttpClient,
    private globalService: GlobalService
  ) {
    super(httpClient, ArchiveCatalogService.PATH, globalService.debugUrl);
  }

  batchCreate(data: BatchArchiveCatalog) {
    return this.httpClient.post<ArchiveCatalog>(
      `${
        this.globalService.debugUrl
          ? this.globalService.debugUrl
          : environment.host
      }${ArchiveCatalogService.PATH}/batchCreate`,
      data
    );
  }

  move(request: ArchiveCatalogMoveRequest) {
    return this.httpClient.post<boolean>(
      `${
        this.globalService.debugUrl
          ? this.globalService.debugUrl
          : environment.host
      }${ArchiveCatalogService.PATH}/move`,
      request
    );
  }

  syncFile(id: number) {
    return this.httpClient.get<boolean>(
      `${
        this.globalService.debugUrl
          ? this.globalService.debugUrl
          : environment.host
      }${ArchiveCatalogService.PATH}/syncFile/${id}`
    );
  }

  clearFile(id: number) {
    return this.httpClient.get<boolean>(
      `${
        this.globalService.debugUrl
          ? this.globalService.debugUrl
          : environment.host
      }${ArchiveCatalogService.PATH}/clearFile/${id}`
    );
  }

  unlock(id: number) {
    return this.httpClient.get<boolean>(
      `${
        this.globalService.debugUrl
          ? this.globalService.debugUrl
          : environment.host
      }${ArchiveCatalogService.PATH}/unlock/${id}`
    );
  }

  lock(id: number) {
    return this.httpClient.get<string>(
      `${
        this.globalService.debugUrl
          ? this.globalService.debugUrl
          : environment.host
      }${ArchiveCatalogService.PATH}/lock/${id}`
    );
  }
}
